import { format } from "date-fns";
import { LogLevels } from "../types/Log/LogLevels";
import { LevelColors } from "../types/Log/LogLevelColors";

const defaultColor = "color: inherit";
export class ConsoleTransport {
  private getConsoleMethod(level: LogLevels) {
    if (level === "ERROR") {
      return console.error;
    }
    if (level === "WARN") {
      return console.warn;
    }
    return console.log;
  }

  private writeFormattedLog(
    level: LogLevels,
    timestamp: string,
    output: any,
    additional: any,
    error?: Error,
  ) {
    const stack = (error as any)?.stack as string | undefined;
    const errorMessage = (error as any)?.message as string | undefined;
    const consoleMethod = this.getConsoleMethod(level);
    if (error) {
      return consoleMethod(
        `%c[%c${level.toUpperCase()} ${timestamp}%c]:`,
        defaultColor,
        `color: ${LevelColors[level.toUpperCase() as LogLevels]};`,
        defaultColor,
        {
          message: output.message || errorMessage,
          ...output,
          ...(additional instanceof Error ? {} : { ...additional }),
          error: { message: errorMessage, stack },
        },
        "\n",
        stack,
      );
    }
    return consoleMethod(
      `%c[%c${level.toUpperCase()} ${timestamp}%c]:`,
      defaultColor,
      `color: ${LevelColors[level.toUpperCase() as LogLevels]};`,
      defaultColor,
      { ...output, ...additional },
    );
  }

  private getError = (message: any, additional: any) => {
    if (message instanceof Error) {
      return message;
    }
    if (additional instanceof Error) {
      return additional;
    }
    if (message instanceof Object && message?.error instanceof Error) {
      return message.error;
    }
    if (additional instanceof Object && additional?.error instanceof Error) {
      return additional.error;
    }
    return undefined;
  };

  public log(info: any) {
    const { level, dts, message, additional, ...rest } = info;
    const timestamp = format(dts, "yyyy-MM-dd HH:mm:ss");
    const output = { level, timestamp, dts, ...rest };
    const error = this.getError(message, additional);
    return this.writeFormattedLog(
      level,
      timestamp,
      {
        ...output,
        ...(!(message instanceof Error) && message instanceof Object
          ? { ...message }
          : { message: message?.message || message }),
      },
      additional,
      error,
    );
  }
}
